// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-body[data-v-bd590d36]{max-height:60vh;overflow-x:hidden;overflow-y:auto}.modal-title[data-v-bd590d36]{background-color:#a0daf8;color:#fff}.rating-container[data-v-bd590d36]{display:flex;justify-content:center;padding:20px 0 0}.headline[data-v-bd590d36]{word-break:normal}#disclaimer[data-v-bd590d36]{font-size:70%}.error-message[data-v-bd590d36]{display:block;font-size:12px!important;text-align:center;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
